// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import Tag from "@insite/mobius/Tag";
import TagsField from "@insite/mobius/TagsField";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import { getGridPreset } from "@toolkit/Framework/Common/Utilities/gridPreset";
import { clearfixStyles } from "@toolkit/Themes/common/mixins";
import React, { FC, useState } from "react";
import { css, useTheme } from "styled-components";

const wrapperCss = css`
    ${clearfixStyles()}
    max-width: 350px;
`;

const contentCss = css`
    display: flex;
    flex-flow: row wrap;
    flex: 1 0 100%;
    margin: -${x => x.theme.tag.gap} 0 0 -${x => x.theme.tag.gap};
`;

const itemCss = css`
    display: flex;
    margin: ${x => x.theme.tag.gap} 0 0 ${x => x.theme.tag.gap};
`;

const StyleguideTags: FC = () => {
    const [tagsFieldId] = useState(`section-${uniqueId()}`);
    const [tagsId] = useState(`section-${uniqueId()}`);
    const theme = useTheme();
    const gridContainerProps = getGridPreset(theme.design.form.grid.base);

    return (
        <>
            <StyleguideSection title="Tags" sectionId={tagsId}>
                <StyledWrapper css={wrapperCss}>
                    <StyledWrapper css={contentCss}>
                        <StyledWrapper css={itemCss}>
                            <Tag>Lorem Ipsum</Tag>
                        </StyledWrapper>
                        <StyledWrapper css={itemCss}>
                            <Tag>Dolor</Tag>
                        </StyledWrapper>
                        <StyledWrapper css={itemCss}>
                            <Tag>Pellentesque commodo porta velit, ut consequat diam feugiat eu</Tag>
                        </StyledWrapper>
                        <StyledWrapper css={itemCss}>
                            <Tag>Sit Amet</Tag>
                        </StyledWrapper>
                        <StyledWrapper css={itemCss}>
                            <Tag>Nam rhoncus viverra diam</Tag>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </StyleguideSection>
            <StyleguideSection title="Tags Field" sectionId={tagsFieldId}>
                <GridContainer {...gridContainerProps}>
                    <GridItem width={4}>
                        <TagsField
                            label="Sit Amet"
                            placeholder="Placeholder"
                            value={["color, nam, rhoncus, lorem ipsum, dolor, pellentesque"]}
                        />
                    </GridItem>
                    <GridItem width={4}>
                        <TagsField
                            label="Sit Amet (Error)"
                            placeholder="Placeholder"
                            value={["color, nam, rhoncus, lorem ipsum, dolor, pellentesque"]}
                            error
                        />
                    </GridItem>
                </GridContainer>
            </StyleguideSection>
        </>
    );
};

export default StyleguideTags;
